module.exports = __webpack_public_path__ + "assets/img/play.78e36fe7.png";